import { render, staticRenderFns } from "./AcademyListTable.vue?vue&type=template&id=dd5d8854&scoped=true&lang=pug&"
import script from "./AcademyListTable.vue?vue&type=script&lang=ts&"
export * from "./AcademyListTable.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyListTable.vue?vue&type=style&index=0&id=dd5d8854&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5d8854",
  null
  
)

export default component.exports